import { ProductsWMSFilterModel } from '@kanzi-apes/kanzi-models';

export const ProductListQueryKeys = {
  all: (filters: ProductsWMSFilterModel | null) => ['productWMSList', filters],
};
